import type { SxProps, Theme } from "@mui/material/styles";

export const root =
  (compact: boolean): SxProps<Theme> =>
  (theme) => ({
    bgcolor: "background.paper",
    border: 1,
    borderColor: "divider",
    borderRadius: 3,
    boxShadow: theme.shadows[compact ? 1 : 3],
    p: compact ? { xs: 3, md: 4 } : { xs: 5, md: 8.75 },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    textAlign: "center",
    minHeight: compact ? undefined : { md: 420 },
  });

export const iconWrap =
  (compact: boolean): SxProps<Theme> =>
  () => ({
    width: compact ? 64 : { xs: 80, md: 100 },
    height: compact ? 64 : { xs: 80, md: 100 },
    borderRadius: compact ? 2.5 : { xs: 2.75, md: 3.5 },
    bgcolor: "background.default",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 0.75,
  });

export const title: SxProps<Theme> = {
  fontSize: { xs: "0.90625rem", md: "1.0625rem" },
  fontWeight: 700,
};

export const description: SxProps<Theme> = {
  fontSize: { xs: "0.75rem", md: "0.8125rem" },
  color: "text.secondary",
  maxWidth: 460,
  lineHeight: 1.8,
};

export const dataSafeText: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
  maxWidth: 460,
  lineHeight: 1.8,
};

export const actionWrap: SxProps<Theme> = {
  mt: 1,
};
